<template lang="pug">
.cp-photo-wall
  .w
    .row
      ul.items-wrap.fix(ref="items-wrap1")
        li.item(v-for="item in photos[0]")
          img(:src="item.url", @click.prevent)
    .row
      ul.items-wrap.fix(ref="items-wrap2")
        li.item(v-for="item in photos[1]")
          img(:src="item.url", @click.prevent)
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      photos: [
        [
          { url: require('@/assets/photo-team1.jpg') },
          { url: require('@/assets/photo-team1.png') },
          { url: require('@/assets/photo-team10.png') },
          { url: require('@/assets/photo-team1.jpg') },
          { url: require('@/assets/photo-team1.png') },
          { url: require('@/assets/photo-team10.png') },
        ],
        [
          { url: require('@/assets/photo-team5.jpg') },
          { url: require('@/assets/photo-team7.jpg') },
          { url: require('@/assets/photo-team11.png') },
          { url: require('@/assets/photo-team5.jpg') },
          { url: require('@/assets/photo-team7.jpg') },
          { url: require('@/assets/photo-team11.png') },
        ],
      ],
      speed1: 0.7,
      speed2: 0.5,
      offsetLeft1: 0,
      offsetLeft2: 0,
    }
  },
  computed: {},
  methods: {
    slidePhotos1 () {
      const itemWrap = this.$refs[`items-wrap1`]
      const self = this
      function move () {
        self.offsetLeft1 += self.speed1
        itemWrap.style.transform = `translate3d(-${self.offsetLeft1}px, 0, 0)`
        if (self.offsetLeft1 >= itemWrap.children[0].offsetWidth * 3) {
          itemWrap.style.transform = `translate3d(0, 0, 0)`
          self.offsetLeft1 = 0
        }
        requestAnimationFrame(move)
      }
      requestAnimationFrame(move)
    },
    slidePhotos2 () {
      const itemWrap = this.$refs[`items-wrap2`]
      const self = this
      function move () {
        self.offsetLeft2 += self.speed2
        itemWrap.style.transform = `translate3d(-${self.offsetLeft2}px, 0, 0)`
        if (self.offsetLeft2 >= itemWrap.children[0].offsetWidth * 3) {
          itemWrap.style.transform = `translate3d(0, 0, 0)`
          self.offsetLeft2 = 0
        }
        requestAnimationFrame(move)
      }
      requestAnimationFrame(move)
    }
  },
  mounted () {
    this.slidePhotos1()
    this.slidePhotos2()
    this.start1 = true
    this.start2 = true
  },
}
</script>
<style lang="stylus">
.cp-photo-wall
  margin-top 82px
  .w
    position relative
    overflow hidden
    &::before
      content ''
      display block
      width 244px
      height 100%
      background linear-gradient(90deg,rgba(15,25,57,1) 0%,rgba(15,25,57,0.76) 37%,rgba(15,25,57,0) 100%)
      position absolute
      left 0
      top 0
      z-index 1
    &::after
      content ''
      display block
      width 244px
      height 100%
      background linear-gradient(270deg,rgba(15,25,57,1) 0%,rgba(15,25,57,0.76) 37%,rgba(15,25,57,0) 100%)
      position absolute
      right 0
      top 0
      z-index 1
    .row
      margin-bottom 10px
      .items-wrap
        position relative
        white-space nowrap
        .item
          display inline-block
          // width 195px
          padding-right 16px
          height 242px
          padding-right 8px
          img
            width 362px
            height 242px
</style>
